<!-- Inner Banner Start-->
  <section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1>Portfolio</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Portfolio</li>
      </ol>
    </nav>
  </div>
</section>

<!-- Inner Banner End -->
<!-- Start Portfolio Area -->
<section class="section portfolio-section">
  <div class="container">
    <div class="d-flex justify-content-center">

      <!--   Portfolio Filters   -->
      <ul id="portfolio-filter" class="portfolio-filter filters">
        <li class="button-border list-inline-item">
          <a href="#" data-filter="*" class="pill-button active">All</a>
        </li>
        <li class="button-border list-inline-item">
          <a href="#" data-filter=".webdesign" class="pill-button">Web Design</a>
        </li>
        <li class="button-border list-inline-item">
          <a href="#" data-filter=".mobiledesign" class="pill-button">Mobile Design</a>
        </li>
        <li class="button-border list-inline-item">
          <a href="#" data-filter=".seo" class="pill-button">Seo</a>
        </li>
        <li class="button-border list-inline-item">
          <a href="#" data-filter=".graphic" class="pill-button">Graphic</a>
        </li>
      </ul>
    </div>
    <div class="portfolio-items row">

      <!-- Item 01 -->
      <div class="col-lg-4 col-sm-6 portfolio-item seo">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/01.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 02 -->
      <div class="col-lg-4 col-sm-6 portfolio-item graphic webdesign">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/02.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 03 -->
      <div class="col-lg-4 col-sm-6 portfolio-item webdesign graphic">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/03.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 04 -->
      <div class="col-lg-4 col-sm-6 portfolio-item mobiledesign webdesign">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/04.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 05 -->
      <div class="col-lg-4 col-sm-6 portfolio-item mobiledesign seo">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/05.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 06 -->
      <div class="col-lg-4 col-sm-6 portfolio-item mobiledesign">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/06.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 07 -->
      <div class="col-lg-4 col-sm-6 portfolio-item mobiledesign webdesign">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/07.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 08 -->
      <div class="col-lg-4 col-sm-6 portfolio-item webdesign graphic">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/08.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
      <!-- Item 09 -->
      <div class="col-lg-4 col-sm-6 portfolio-item seo">
        <div class="image-border">
          <div class="portfolio-box">
            <img src="assets/images/portfolio/09.jpg" class="img-fluid" alt="">
            <div class="portfolio-icon d-flex align-items-center justify-content-center">
              <a href="assets/images/portfolio/big/01.jpg" class="js-zoom-gallery">
                <i class="mdi mdi-magnify-plus-outline"></i>
              </a>
            </div>
            <div class="img-overlay text-center">
              <h5 class="mb-0">My Work</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Portfolio Area -->
